<template>
	<div class="mdc-layout-grid login__body">

		<div class="login mdc-layout-grid__inner">

			<!-- First Column -->
			<div class="login__first-col mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-theme--primary-dark-bg mq-md-hidden center-horizontal">
				<div class="login__first-col__logo-wrapper">
					<a href="https://bestagent.co.uk" target="_blank"><img class="login__first-col__logo" src="/static/img/logo.png" alt=""></a>
					<p>Move people.</p>
				</div>
				<div class="login__first-col__email-wrapper" style="width:100%">
					<a href="mailto:support@bestagent.ltd">support@bestagent.ltd</a>
				</div>
			</div>
			 <!-- Second Column -->
		    <div class="login__second-col mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet center-horizontal mdc-theme--text-primary-on-light">
					<div class="">
						<nav class="login__title-toggle">
							<div class="login__logo">
								<a href="https://bestagent.co.uk"><img class="" src="/static/img/logo.png" alt=""></a>
							</div>
							<div class="login__title">
								<a class="login__title-half" @click.prevent="stage = stages.ENTRY" :class="{'login__title--active': stage == stages.ENTRY}">Login</a>
								<a class="login__title-half" @click.prevent="stage = stages.NEW_USER" :class="{'login__title--active': stage == stages.NEW_USER || stage == stages.NEW_USER_EMAIL || stage == stages.NEW_USER_EMAIL_SUCCESS}">New User</a>
								<span class="mdc-tab-bar__indicator login__title-indicator--grey"></span>
								<span class="mdc-tab-bar__indicator login__title-indicator" :class="{'login__title-indicator--new': stage == stages.NEW_USER || stage == stages.NEW_USER_EMAIL || stage == stages.NEW_USER_EMAIL_SUCCESS}"></span>
							</div>
						</nav>
						<div class="" v-if="stage !== stages.ENTRY || stages.NEW_USER || stages.NEW_USER_EMAIL">
							<span class="login__title"></span>
						</div>
					</div>

 					<!-- ENTRY LOGIN -->
					<section class="login__section section-loginEntry" v-if="stage == stages.ENTRY">
						<div class="social-buttons">
						   <a id="facebook" href="#" @click.prevent="loginFB" class="mdc-button mdc-button--raised btn--spinner button button--facebook button-social">
						   <span class="mdc-button__icon" alt="facebook"></span></a>
						   <a id="linkedin" href="#" @click.prevent="loginLinkedin" class="mdc-button mdc-button--raised btn--spinner button button--linkedin button-social">
						   <span class="mdc-button__icon" alt="linkedin"></span></a>
						   <a id="google" href="" @click.prevent="loginGoogle" class="mdc-button mdc-button--raised btn--spinner button button--google button-social">
						   <span class="mdc-button__icon" alt="google"></span></a>
						</div>
						<div class="divider-title"><span>Or</span></div>
						<form id="form-login" method="post" data-vv-scope="form-login">
							<div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top" :class="{'login__input--invalid': errors.has('form-login.email') && fields['$form-login'].email.touched || (submitErrors.loginEmail && user.email == '')}">
								 <input id="email" v-validate="'required|email'" type="text" v-model="user.email" class="mdc-textfield__input" name="email" @keyup.enter="loginCognito" tabindex="0" data-lpignore="true">
								 <label for="email" class="mdc-textfield__label mdc-textfield__label--float-above">Email *</label>
							</div>
							<span v-show="errors.has('form-login.email') && fields['$form-login'].email.touched" class="login__error login__error--left">{{ errors.first('form-login.email') }}</span>

							<div class="width-100 mdc-textfield mdc-textfield--upgraded login__input--show" :class="{'login__input--invalid': errors.has('form-login.password') || (submitErrors.loginEmail && user.password == '')}">
								 <vue-password v-model="user.password" v-validate="'required'" class="width-100" :disableStrength="true" :classes="'mdc-textfield__input'" :user-inputs="[user.password]" :disableToggle="user.password == '' ? true : false" name="password" @keyup.native.enter="loginCognito" tabindex="0" data-lpignore="true"></vue-password>
								 <label for="password" class="mdc-textfield__label mdc-textfield__label--float-above">Password *</label>
							</div>
							<span v-show="errors.has('form-login.email')" class="login__error login__error--left">{{ errors.first('form-login.password') }}</span>
							<span class="login__small-text login__small-text--right" @click.prevent="stage=stages.FORGOT_PASSWORD">Forgot password?</span>
							<!-- <div class="width-100 mdc-form-fieldcheckbox">
								<div class="mdc-checkbox">
									 <input type="checkbox" id="remember">
									 <label for="remember">Remember me</label>
								 </div>
							</div> -->

							<a href="" id="login" class="mdc-button mdc-button--raised mdc-button-submit btn--spinner btn--spinner__wide-btn" @click.prevent="loginCognito" tabindex="0">Login</a>
							<div class="login__error" v-if="submitErrors.loginEmail" v-html="submitErrors.loginEmail"></div>
						</form>

						<div class="login__second-col__question">
							<p>
									<span class="login__small-text">Don't have an account?</span><br />
									<a class="login__link login__link--big" href="" @click.prevent="stage=stages.NEW_USER">Sign up for free</a>
							</p>
						</div>
					</section>

				    <!-- FORGOT PASSWORD -->
				    <section class="login__section section-forgotPassword" v-if="stage == stages.FORGOT_PASSWORD">
							<h3 class="login__section-text login__section-text--blue">Forgot your password?</h3>
							<h4 class="login__section-text">Fill in your email below and we'll send you a password reset link</h4>
							<form id="form-forgot" method="post" data-vv-scope="form-forgot">
								<div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'login__input--invalid': errors.has('form-forgot.email') || (submitErrors.forgotPassword && forgotEmail == '')}">
									<input id="email" v-validate="'required|email'" data-vv-delay="1000" v-model="user.email" class="mdc-textfield__input" name="email" tabindex="0" @keyup.enter="resetPassword">
									<label for="email" class="mdc-textfield__label mdc-textfield__label--float-above">Email</label>
								</div>
								<span v-show="errors.has('form-forgot.email')" class="login__error login__error--left">{{ errors.first('form-forgot.email') }}</span>

								<a href="" id="forgotPassword" class="mdc-button mdc-button-submit btn--spinner btn--spinner__wide-btn" @click.prevent="resetPassword" tabindex="0">Send</a>
								<div class="login__error" v-if="submitErrors.forgotPassword">{{submitErrors.forgotPassword}}</div>
							</form>
							<div class="login__second-col__question">
								<div class="btn-back">
								   <p><a href="#" class="login__link" @click.prevent="stage = stages.ENTRY">&lt; back</a></p>
								</div>
							</div>

				    </section>

					 <!-- FORGOT PASSWORD SUCCESS -->
					 <section class="login__section section-forgotPassword" v-if="stage == stages.FORGOT_PASSWORD_SUCCESS">

							<h3 class="login__section-text login__section-text--blue">Please check your email to reset your password!</h3>
							<div class="login__second-col__question">
								<div class="btn-back">
									<p><a href="#" class="login__link" @click.prevent="stage = stages.ENTRY">&lt; back</a></p>
								</div>
							</div>
					 </section>

					 <!-- RESET PASSWORD -->
				    <section class="section-resetPassword login__section" v-if="stage == stages.RESET_PASSWORD">
							<h3 class="login__section-text login__section-text--blue">Reset password</h3>
							<h4 class="login__section-text">Please enter your new password:</h4>
							<form id="form-reset" action="index.html" method="post" data-vv-scope="form-reset">
								<div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'login__input--invalid': errors.has('form-reset.password') || (submitErrors.resetPassword && newPassword == '')}">
									<vue-password v-model="newPassword" class="width-100" :classes="'mdc-textfield__input'" :disableStrength="newPassword == '' ? true : false" :disableToggle="newPassword == '' ? true : false" name="password" tabindex="0" @keyup.native.enter="changePassword"></vue-password>
									<label for="password" class="mdc-textfield__label mdc-textfield__label--float-above">New Password</label>
								</div>
								<span v-show="errors.has('form-reset.password')" class="login__error login__error--left">{{ errors.first('form-reset.password') }}</span>

								<a href="" id="resetPassword" class="mdc-button mdc-button-submit btn--spinner btn--spinner__wide-btn" @click.prevent="changePassword" tabindex="0">Reset Password</a>
								<div class="login__error" v-if="submitErrors.resetPassword" v-html="submitErrors.resetPassword"></div>
							</form>

							<div class="login__second-col__question">
								<div class="btn-back">
								   <p><a href="#" class="login__link" @click.prevent="stage = stages.ENTRY">&lt; back</a></p>
								</div>
							</div>
				    </section>

					 <!-- RESET PASSWORD SUCCESS -->
					 <section class="login__section section-resetPassword" v-if="stage == stages.RESET_PASSWORD_SUCCESS">
							<h3 class="login__section-text login__section-text--blue">Your password was changed successfully!</h3>
							<h4 class="login__section-text">Please login to your account:</h4>
							<a href="" class="mdc-button mdc-button--raised mdc-button-submit btn--spinner btn--spinner__wide-btn" @click.prevent="stage = stages.ENTRY">Login</a>
					 </section>

				    <!-- NEW ACCOUNT -->
				    <section class="login__section section-newUser" v-if="stage == stages.NEW_USER">
							<h4 class="login__section-text">Use social media to set up a demo account and discover BestAgent for yourself.</h4>
							<div class="social-buttons">
							<div class="">
								<a href="#" id="facebook" @click.prevent="loginFB" class="mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn button button--facebook">
								<span class="mdc-button__icon btn__icon" alt="facebook"></span>Facebook</a>
							</div>
							<div class="">
								<a href="#" id="linkedin" @click.prevent="loginLinkedin" class="mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn button button--linkedin">
								<span class="mdc-button__icon btn__icon" alt="linkedin"></span>LinkedIn</a>
							</div>
							<div class="">
								<a href="#" id="google" @click.prevent="loginGoogle" class="mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn button button--google">
								<span class="mdc-button__icon btn__icon" alt="google"></span>Google</a>
							</div>
						</div>

							<div class="divider-title"><span>Or</span></div>

							<div class="">
								<a href="#" class="mdc-button mdc-button--raised" @click.prevent="stage = stages.NEW_USER_EMAIL">Sign up with Email</a>
							</div>

							<div class="login__second-col__question">
								<p>Already have an account?<br />
							  <a href="#" class="login__link login__link--big" @click.prevent="stage = stages.ENTRY; attentionSymbol = false">Log in here</a></p>
							</div>
				    </section>

					 <!-- NEW ACCOUNT WITH EMAIL -->
					 <section class="login__section section-newUserEmail" v-if="stage == stages.NEW_USER_EMAIL">
						 	<form id="form-new" method="post" data-vv-scope="form-new">
								<div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'login__input--invalid': errors.has('form-new.name') || (submitErrors.newAccount && newUser.name == '')}">
									<input id="first-name" v-validate="'required'" type="text" v-model="newUser.name" class="mdc-textfield__input" name="name" tabindex="0" @keyup.enter="createNewAccount" data-lpignore="true">
									<label for="first-name" class="mdc-textfield__label mdc-textfield__label--float-above">Full Name *</label>
								</div>
								<span v-show="errors.has('form-new.name')" class="login__error login__error--left">{{ errors.first('form-new.name') }}</span>

								<div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'login__input--invalid': errors.has('form-new.email') && fields['$form-new'].email.touched || (submitErrors.newAccount && newUser.email == '')}">
								  	<input id="newEmail" v-validate="'required|email'" type="text" v-model="newUser.email" class="mdc-textfield__input" name="email" tabindex="0" @keyup.enter="createNewAccount" data-lpignore="true">
									<label for="newEmail" class="mdc-textfield__label mdc-textfield__label--float-above">Email *</label>
								</div>
								<span v-show="errors.has('form-new.email') && fields['$form-new'].email.touched" class="login__error login__error--left">{{ errors.first('form-new.email') }}</span>

								<div class="width-100 mdc-textfield mdc-textfield--upgraded" :class="{'login__input--invalid': errors.has('form-new.newPassword') || (submitErrors.newAccount && newUser.password == '')}">
									<vue-password id="newPassword" v-model="newUser.password" v-validate="'required'" class="width-100" :classes="'mdc-textfield__input'" :disableStrength="newUser.password == '' ? true : false" :disableToggle="newUser.password == '' ? true : false" :user-inputs="[newUser.email]" name="newPassword" tabindex="0" @keyup.native.enter="createNewAccount" data-lpignore="true"></vue-password>
									<label for="newPassword" class="mdc-textfield__label mdc-textfield__label--float-above">Password *</label>
								</div>
								<span v-show="errors.has('form-new.newPassword')" class="login__error login__error--left">{{ errors.first('form-new.newPassword') }}</span>

								<a href="" id="createAccount" class="mdc-button mdc-button--raised mdc-button-submit btn--spinner btn--spinner__wide-btn" @click.prevent="createNewAccount" tabindex="0">Get Started</a>
								<div class="login__error" v-if="submitErrors.newAccount" v-html="submitErrors.newAccount"></div>
							</form>

							<div class="login__second-col__question">
								<div class="btn-back">
									<p><a href="#" class="login__link" @click.prevent="stage = stages.NEW_USER">&lt; back</a></p>
								</div>
							</div>
					 </section>

					 <!-- NEW ACCOUNT WITH EMAIL -->
					 <section class="login__section section-newUserEmail" v-if="stage == stages.NEW_USER_EMAIL_SUCCESS">
							<h3 class="login__section-text login__section-text--blue">One more step, {{newUser.name.split(' ')[0]}}!</h3>
							<h4 class="login__section-text login__section-text--blue">Please click the link in the email we have just sent to {{newUser.email}} to activate your account.</h4>
							<h4 class="login__section-text login__section-text--blue">You’ll then be able to login to BestAgent and have a look around.</h4>

							<div class="login__second-col__question">
								<div class="btn-back">
									<p><a href="#" class="login__link" @click.prevent="stage = stages.NEW_USER">&lt; back</a></p>
								</div>
							</div>
					 </section>

					 <!-- ACTIVATE ACCOUNT -->
				    <section class="login__section section-emailLogin" v-if="stage == stages.ACTIVATE_ACCOUNT">
				        <h3 class="login__section-text login__section-text--blue" v-if="!activated">Activating your account...</h3>
							<div v-if="activated">
								<p>Thank you, your account was successfully activated.</p>
								<p>Please click the button below to login to your BestAgent account:</p>
								<a href="" class="mdc-button mdc-button--raised mdc-button-submit btn--spinner btn--spinner__wide-btn" @click.prevent="stage = stages.ENTRY">Login</a>
							</div>
						<div v-else class="login__error" v-html="submitErrors.activateAccount"></div>
				    </section>
			 </div>
		</div>
	</div>
</template>

<script>
import { login, isLoggedIn } from '@/libs/auth';
import { init as initFB } from '@/libs/providers/fb';
import { init as initGoogle } from '@/libs/providers/google';
import { signUp, confirmCode, confirmPassword, forgotPassword } from '@/libs/providers/cognito';
import { linkedinLogin, linkedinCallback } from '@/libs/providers/linkedin';
import {config} from '@/config';
import axios from 'axios';
import qs from 'querystring';

export default {
	name: 'Login',
	props: ['newUserFlag','activateAccountFlag', 'resetPasswordFlag', 'linkedinLoginFlag'],
	data: function() {
		return {
			stage: this.newUserFlag ? 2 : this.activateAccountFlag ? 4 : this.resetPasswordFlag ? 7 : this.linkedinLoginFlag ? 0 : 0,
			stages: {
				ENTRY:              0,
				FORGOT_PASSWORD:    1,
				NEW_USER:           2,
				NEW_USER_EMAIL:     3,
				ACTIVATE_ACCOUNT:   4,
				NEW_USER_EMAIL_SUCCESS: 5,
				FORGOT_PASSWORD_SUCCESS: 6,
				RESET_PASSWORD: 7,
				RESET_PASSWORD_SUCCESS: 8
			},
			newUser: {
				name: '',
				email: '',
				password: ''
			},
			user: {
				email: '',
				password: ''
			},
			forgotEmail: '',
			newPassword: '',
			activated: false,
			activationerror: false,
			attentionSymbol: false,
			submitErrors: {
				loginEmail: '',
				forgotPassword: '',
				resetPassword: '',
				newAccount: '',
				activateAccount: ''
			}
		}
	},
	created: function() {
		if(this.activateAccountFlag) {
			this.validateCode();
		}
		if(this.linkedinLoginFlag){
 			const code = this.$route.query.code;
			const state = this.$route.query.state;
			login('linkedin', code, state);
		}
		initFB();
		initGoogle();
	},
	mounted: function() {
		if(this.linkedinLoginFlag){
			this.showSpinner('linkedin');
		}
	},
	methods: {
		showSpinner(id) {
			var element = document.getElementById(id);
			element.classList.add('btn-spin--visible');
		},
		hideSpinner(id) {
			var element = document.getElementById(id);
			element.classList.remove('btn-spin--visible');
		},
		loginFB() {
			this.showSpinner('facebook');
			login('facebook');
		},
		loginGoogle() {
			this.showSpinner('google');
			login('google');
		},
		loginLinkedin() {
			this.showSpinner('linkedin');
			linkedinLogin();
		},
		async loginCognito() {
			try {
				this.submitErrors.loginEmail = '';
				this.showSpinner('login');
				await login('cognito', this.user.email, this.user.password);
			} catch(err) {
				this.hideSpinner('login');
				if(typeof err == 'string') {
					this.submitErrors.loginEmail = err;
				} else {
					this.submitErrors.loginEmail = 'Whoops! Please try again or contact our live chat.';
				}
			}
		},
		async createNewAccount() {
			if(this.newUser.name == '' || this.newUser.email == '' || this.newUser.password == '') {
				if(this.newUser.name == '') {
					this.newUser.name = '.';
					const that = this;
					window.setTimeout(function() {
						that.newUser.name = '';
					}, 50);
				}
				return;
			}
			try {
				this.submitErrors.newAccount = '';
				this.showSpinner('createAccount');
				const user = await signUp(this.newUser);
				this.stage = this.stages.NEW_USER_EMAIL_SUCCESS;
			} catch(err) {
				this.hideSpinner('createAccount');
				this.submitErrors.newAccount = err;
			}
		},
		async validateCode() {
			const username = this.$route.params.username;
			const code = this.$route.params.code;
			try {
				this.submitErrors.activateAccount = '';
				await confirmCode(username, code);
				this.user.email = username.replace('_._', '@');
			} catch(err) {
				this.submitErrors.activateAccount = err;
				this.activationerror = true;
			}
			this.activated = true;
		},
		async resetPassword() {
			try {
				this.submitErrors.forgotPassword = '';
				this.showSpinner('forgotPassword');
				await forgotPassword(this.user.email);
				this.stage = this.stages.FORGOT_PASSWORD_SUCCESS;
			} catch(err) {
				this.hideSpinner('forgotPassword');
				this.submitErrors.forgotPassword = err;
			}
		},
		async changePassword() {
			const username = this.$route.params.username;
			const code = this.$route.params.code;
			try {
				this.submitErrors.resetPassword = '';
				this.showSpinner('resetPassword');
				await confirmPassword(username, code, this.newPassword);
				this.stage = this.stages.RESET_PASSWORD_SUCCESS;
			} catch(err) {
				this.hideSpinner('resetPassword');
				this.submitErrors.resetPassword = err;
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue